import { MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// COMPONENTS
// ASSETS
import { BsChevronRight, BsChevronLeft } from 'react-icons/bs';
import { HomeSectionContainer, HomeSectionWrapper } from './HomeSection.style';

interface HomeSectionProps {
	title?: string;
	nav_type?: string;
	children?: JSX.Element | string;
	viewDisabled?: boolean;
	nextHandle?: MouseEventHandler<SVGElement>;
	prevHandle?: MouseEventHandler<SVGElement>;
	viewAllLink?: string;
	className?: string;
	nextDisabled?: boolean;
	prevDisabled?: boolean;
}
const HomeSection = ({
	viewAllLink,
	title,
	nav_type,
	children,
	viewDisabled,
	nextHandle,
	prevHandle,
	prevDisabled,
	nextDisabled,
	className = '',
}: HomeSectionProps) => {
	const { t } = useTranslation();
	const classes = 'transition-colors duration-150 ease-in-out text-[#01ABC1] pointer-events-auto cursor-pointer hover:text-cyan-700';
	return (
		<HomeSectionWrapper className={className}>
			{title && (
				<div className="section-header">
					<div className="section-title">{title}</div>
					<div className="section-nav text__default">
						{nav_type === 'view-all' && (
							<Link to={viewAllLink!} className="text-decoration-none">
								<p>
									{t('view_all')}
									<i className="pi pi-arrow-right ml-1"></i>
								</p>
							</Link>
						)}
						{nav_type === 'carousel' && (
							<div className="text__default flex flex-row gap-6">
								<BsChevronLeft onClick={prevHandle} className={`${classes} ${prevDisabled ? 'pointer-events-none cursor-default opacity-50' : ''}`} />
								<BsChevronRight
									onClick={nextHandle}
									className={`${classes} ${nextDisabled ? 'pointer-events-none cursor-default opacity-50' : ''}`}
								/>
							</div>
						)}
					</div>
				</div>
			)}
			<HomeSectionContainer>{children}</HomeSectionContainer>
		</HomeSectionWrapper>
	);
};
export default HomeSection;
